module.exports = __webpack_public_path__ + "img/dividends.cd6f9e3c.svg";